'use client';

import { useNewsletterSubscribeForm } from '@/hooks/newsletter/useSubscribeNewsletterForm';
import { NewsletterFooterSignUp } from '@/modules/footer/NewsletterFooterSignUp';
import { subscribeToNewsletter } from '@/utils/actions/homepage/subscribeToNewsletter';
import { CaptchaAction } from '@/utils/helpers/captcha-actions';
import {
  NEWSLETTER_FOOTER_COVER_IMAGE_URL,
  NEWSLETTER_FOOTER_IMAGE_URL,
  NEWSLETTER_FOOTER_MOBILE_IMAGE_URL,
} from '@/utils/helpers/constants';

export const NewsletterFooterSignUpWrapper = () => {
  const { email, onEmailChange, handleSubscribe, displayError, isPending, isSuccess } =
    useNewsletterSubscribeForm(subscribeToNewsletter, CaptchaAction.NEWSLETTER_SUBSCRIBE);

  const sharedProps = {
    email,
    onEmailChange,
    handleSubscribe,
    displayError,
    isPending,
    isSuccess,
  };

  return (
    <div className='flex w-full items-center justify-center bg-gray-100 sm:pt-[100px]'>
      <div className='hidden sm:flex justify-center w-full bg-black overflow-x-clip overflow-y-visible'>
        <div
          className='relative flex items-center justify-center w-full max-w-[1440px] h-[316px]'
          style={{
            backgroundImage: `url(${NEWSLETTER_FOOTER_IMAGE_URL})`,
            backgroundPosition: 'center top',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'auto',
          }}
        >
          <div
            className='absolute left-1/2 -translate-x-1/2 bottom-0'
            style={{
              width: '1440px',
              height: '432px',
              backgroundImage: `url(${NEWSLETTER_FOOTER_COVER_IMAGE_URL})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
            }}
          />

          <div className='relative z-10 mx-auto w-full max-w-[1280px] pt-10'>
            <NewsletterFooterSignUp btnSize='md' {...sharedProps} />
          </div>
        </div>
      </div>
      <div
        className='flex sm:hidden items-center justify-center p-6 w-full bg-transparent'
        style={{
          backgroundImage: `url(${NEWSLETTER_FOOTER_MOBILE_IMAGE_URL})`,
          backgroundPosition: 'center top',
          backgroundSize: 'cover',
        }}
      >
        <NewsletterFooterSignUp btnSize={'sm'} {...sharedProps} />
      </div>
    </div>
  );
};
